<template>
  <div class="message-div">
    <template v-if="clientType">
      {{ $t('congratulations_on_joining') }}
      <br>
      {{ $t('login_code_receiving') }}
    </template>
    <template v-else>
      {{ $t('documents_uploaded') }}
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Completed',

  computed: {
    ...mapState({
      clientType: state => state.clients.type,
    }),
  },
};
</script>

<style scoped>

</style>
